export const PopupDownloadComponent = {
  bindings: {
    title: '@',
    desc: '@',
    percent: '<',
  },
  templateUrl: 'components/Popup/popup-download/popup-download.html',
};
